var _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTellUs = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 70,
    viewBox: "0 0 86 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.719 56.8383C10.719 56.8383 -0.851962 45.2674 3.21349 25.9565C8.99895 -1.71986 45.0408 -0.234409 56.6117 3.04923C68.1826 6.33286 88.7444 12.1965 81.9426 45.7365C75.1408 79.2765 25.4113 66.4546 20.7204 64.5C16.0295 62.5455 10.719 56.8383 10.719 56.8383Z",
    fill: "#FAFAFB",
    stroke: "#040222",
    strokeWidth: 0.781818,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_581_32537",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 82,
    height: 68
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.719 56.8383C10.719 56.8383 -0.851962 45.2674 3.21349 25.9565C8.99895 -1.71986 45.0408 -0.234409 56.6117 3.04923C68.1826 6.33286 88.7444 12.1965 81.9426 45.7365C75.1408 79.2765 25.4113 66.4546 20.7204 64.5C16.0295 62.5455 10.719 56.8383 10.719 56.8383Z",
    fill: "#040222"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_581_32537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0971 45.4202C71.2132 44.0743 68.4426 42.35 68.4426 42.35C68.4426 42.35 60.1697 43.3094 54.1147 43.6085C52.6179 43.6085 49.8928 45.3954 48.7173 46.2889C44.3994 46.2889 34.9384 43.663 30.7477 42.35L38.4993 35.318L36.7462 27.8971C33.2124 29.3106 25.4237 32.7736 22.5401 35.318C18.9355 38.4984 16.4564 42.35 24.7285 50.3846C31.3461 56.8122 44.1429 61.3245 50.3867 62.0438L51.7319 100.765H66.7715C74.0644 100.765 87.6289 100.466 87.6289 100.466L85.428 68.5927C85.6371 67.9659 85.8525 67.305 86.0753 66.6053C89.8946 54.6107 82.6982 49.434 74.0971 45.4202Z",
    fill: "#6F86FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.428 68.5927L87.6289 100.466C87.6289 100.466 74.0644 100.765 66.7715 100.765C59.4786 100.765 51.7319 100.765 51.7319 100.765L50.3867 62.0438M50.3867 62.0438V57.9388M50.3867 62.0438C44.1429 61.3245 31.3461 56.8122 24.7285 50.3846C16.4564 42.35 18.9355 38.4984 22.5401 35.318C25.4237 32.7736 33.2124 29.3106 36.7462 27.8971L38.4993 35.318L30.7477 42.35C34.9384 43.663 44.3994 46.2889 48.7173 46.2889C49.8928 45.3954 52.6179 43.6085 54.1147 43.6085C60.1697 43.3094 68.4426 42.35 68.4426 42.35C68.4426 42.35 71.2132 44.0743 74.0971 45.4202C82.6982 49.434 89.8946 54.6107 86.0753 66.6053C82.8161 76.8406 81.1649 78.7584 77.0492 87.0662",
    stroke: "#040222",
    strokeWidth: 0.625455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9614 -2.15683L47.1531 0.369863L44.4825 5.80894L37.2908 3.28225L39.9614 -2.15683Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 0.625455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.141 3.87857L64.3328 6.40526L61.6622 11.8443L54.4704 9.31765L57.141 3.87857Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 0.625455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.245 73.0822L30.0667 -2.95641L69.7697 10.9926L35.4579 87.0312L-4.245 73.0822Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 0.625455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.38131 72.9943L29.9183 -3.00975L35.9169 -0.902255L1.61725 75.1018L-4.38131 72.9943Z",
    fill: "#6F86FF",
    stroke: "#040222",
    strokeWidth: 0.625455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.354 35.7082C62.354 35.7082 62.2943 40.1853 57.3994 40.5435C57.0412 40.5435 56.683 40.4838 56.3846 40.4241C52.4447 39.1705 51.8478 33.0219 50.833 27.1122C50.5345 23.5305 48.087 20.1279 55.6682 20.0085C59.0111 19.9488 62.6525 24.7244 62.6525 24.7244L65.2122 29.8146L67.0102 36.6036L68.4375 42.3573C68.4375 42.3573 61.9959 45.5578 59.0111 44.7818C56.0264 44.0655 56.4443 42.5731 56.4443 42.5731L55.7876 40.4241",
    fill: "#9C768C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.354 35.7082C62.354 35.7082 62.2943 40.1853 57.3994 40.5435C57.0412 40.5435 56.683 40.4838 56.3846 40.4241C52.4447 39.1705 51.8478 33.0219 50.833 27.1122C50.5345 23.5305 48.087 20.1279 55.6682 20.0085C59.0111 19.9488 62.6525 24.7244 62.6525 24.7244L65.2122 29.8146L67.0102 36.6036L68.4375 42.3573C68.4375 42.3573 61.9959 45.5578 59.0111 44.7818C56.0264 44.0655 56.4443 42.5731 56.4443 42.5731L55.7876 40.4241",
    stroke: "#040222",
    strokeWidth: 0.625455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7734 28.9031C58.7734 28.9031 58.4153 27.7092 57.2214 27.7092C56.4453 27.7689 56.3856 28.9031 56.3856 28.9031",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6992 28.7247C53.6992 28.7247 53.5798 27.6501 52.6844 27.6501C51.789 27.6501 51.9084 28.844 51.9084 28.844",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5195 28.9631V27.7692",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6836 28.7247V27.6501",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4589 31.4107C57.4589 31.4107 57.3395 30.6944 56.7425 31.0526C56.1456 31.4107 55.9665 32.6046 55.1905 32.5449C54.4144 32.4852 54.3547 31.6495 53.8175 31.948C53.1609 32.3061 53.2802 33.321 54.2354 33.8582C55.1905 34.3955 57.817 33.6791 57.4589 31.4107Z",
    fill: "#C693AF",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8633 31.7688C56.8633 31.7688 55.9082 34.276 54.0576 32.7836",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8945 30.9924C54.8945 30.9924 53.3425 30.9924 53.3425 29.9776C53.3425 28.9628 54.5961 27.7092 54.5961 27.7092",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8031 16.6064C51.0118 16.2482 51.1312 20.5463 50.1761 20.5463C49.2209 20.5463 49.3403 17.8003 51.3699 16.1885C53.3996 14.5768 55.071 19.4718 53.9965 19.7702C52.922 20.0687 52.922 15.4125 54.5338 15.2334C56.1455 14.9947 58.1155 18.3973 56.6828 18.636C55.2501 18.8748 56.444 16.0692 58.593 16.0095C60.742 15.9498 61.6971 19.5911 60.3838 19.1136C59.1303 18.5763 60.0854 12.6666 61.8165 17.0243C63.5477 21.382 67.0039 36.6238 67.0039 36.6238L62.0553 28.9035L61.8762 28.9632C61.8762 28.9632 61.1002 29.5602 60.0854 23.5907C60.0854 23.5907 58.6527 24.6055 58.1154 23.8295C57.5782 23.0534 57.5185 23.4713 57.5185 23.4713C57.5185 23.4713 57.22 24.307 56.2052 24.2473C55.1904 24.1876 54.7129 23.1728 54.7129 23.1728C54.7129 23.1728 54.8919 24.4264 53.8174 24.3667C52.7429 24.307 52.3848 23.3519 52.3848 23.3519C52.3848 23.3519 52.5638 24.7846 51.7878 24.7846C51.0118 24.7846 50.1164 23.7101 50.1164 23.7101",
    fill: "#ED7976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3585 24.448C50.3585 24.448 47.7283 16.9049 49.0416 16.4871C50.3549 16.0692 52.6233 20.4866 51.6682 20.4866C50.713 20.4866 49.4594 18.0988 51.4891 16.4871C53.5187 14.8753 55.1901 19.7703 54.1156 20.0688C53.0411 20.3672 53.0411 15.7111 54.6529 15.532C56.2646 15.3529 58.2346 18.6958 56.8019 18.9346C55.3692 19.1733 56.6228 16.4871 58.7121 16.308C60.6821 16.1289 61.279 20.0091 60.0254 19.4718C58.5927 18.8152 60.2642 12.9651 61.9356 17.3228C63.6071 21.6805 67.0469 36.7212 67.0469 36.7212",
    stroke: "#040222",
    strokeWidth: 0.625455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2227 28.3067C61.2227 28.3067 60.6854 25.8592 60.2675 23.5908C60.2675 23.5908 58.8349 24.6056 58.2976 23.8296C57.7604 23.0536 57.7007 23.4714 57.7007 23.4714C57.7007 23.4714 57.4022 24.3072 56.3874 24.2475C55.3726 24.1878 54.895 23.173 54.895 23.173C54.895 23.173 55.0741 24.4266 53.9996 24.3669C52.9848 24.3072 52.5669 23.3521 52.5669 23.3521C52.5669 23.3521 52.746 24.7847 51.97 24.7847C51.1939 24.7847 50.2985 23.7102 50.2985 23.7102",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1734 28.9036C62.1734 28.9036 63.0091 27.5306 63.9045 28.426C64.7999 29.3214 64.9193 31.4704 62.7703 31.3511",
    fill: "#9C768C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1734 28.9036C62.1734 28.9036 63.0091 27.5306 63.9045 28.426C64.7999 29.3214 64.9193 31.4704 62.7703 31.3511",
    stroke: "#040222",
    strokeWidth: 0.625455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4885 31.4701L65.9297 34.8315",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.934 37.4399C61.934 37.4399 62.4713 42.6334 57.1584 43.29C56.6809 41.9767 56.2033 40.5441 56.2033 40.5441C56.2033 40.5441 60.7998 42.2155 61.934 37.4399Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.716725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.508 61.0907C39.3828 59.5755 39.0871 58.0594 38.4692 56.5854C37.8445 55.0951 35.6212 51.5163 34.1107 51.7918C32.7064 52.0479 35.6313 55.7394 35.927 56.4826C36.1343 57.0039 36.8389 58.575 35.4802 58.0707C34.1214 57.5664 28.7541 53.5904 26.3958 51.3883C24.0374 49.1861 23.6831 50.9429 24.1829 51.7918C24.3653 52.1015 25.0043 52.7372 25.8087 53.4716C24.3796 52.3454 23.9406 52.2541 23.6444 52.7672C23.398 53.194 23.796 54.2155 24.5716 55.3047C23.6263 54.8115 22.8245 54.5537 22.5996 54.9431C22.3176 55.4317 23.0189 56.4372 24.0243 57.4738C23.0927 56.7159 22.5946 56.4209 22.5996 57.006C22.6093 58.1323 24.7214 61.5367 29.5497 64.6045C31.4708 65.8251 34.1746 67.4089 36.9288 68.9684L41.1956 62.9367C40.1585 62.2915 39.251 61.6724 38.508 61.0907Z",
    fill: "#9C768C",
    stroke: "#040222",
    strokeWidth: 0.625455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1602 74.0998C71.1389 69.6019 74.2767 62.9095 74.2771 60.1029",
    stroke: "#040222",
    strokeWidth: 0.716725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9532 60.9514C46.0363 63.3871 71.6257 76.2142 71.6257 76.2142L77.1383 86.2614C73.4929 92.7521 68.8222 89.623 64.9989 87.3112C61.9403 85.4618 43.8409 74.3152 35.0977 69.6028C35.0977 69.6028 38.4116 61.9045 40.9532 60.9514Z",
    fill: "#6F86FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2264 75.8584C73.2264 75.8584 47.1959 64.8028 41.059 61.1622C37.8626 62.1362 35.3086 69.5498 35.3086 69.5498C44.0519 74.2623 61.355 85.9749 64.6403 87.3829C69.1625 89.321 73.2264 91.6166 77.1387 86.2613",
    stroke: "#040222",
    strokeWidth: 0.625455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.086 31.3494L13.1211 30.4317L13.3583 29.1345L14.6082 29.8782L14.086 31.3494Z",
    fill: "#9C768C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9056 31.4382C13.9056 31.4382 11.7789 29.5355 11.3604 28.2975C10.9461 27.078 11.0731 25.0046 11.6395 23.2931C12.2059 21.5816 14.0947 18.8096 15.2935 19.5638C16.4923 20.3181 17.7034 21.567 18.8525 22.588C19.9983 23.6154 20.7282 24.2363 20.3092 24.9513C19.8902 25.6662 17.1241 24.1262 16.4567 23.6523C16.4567 23.6523 18.5985 25.7257 18.8823 25.9974C19.1783 26.2593 19.4249 26.8939 19.2025 27.3952C18.9891 27.893 18.1469 27.3919 17.9168 27.2706C17.6922 27.1521 15.884 26.0929 15.884 26.0929C15.884 26.0929 18.143 27.8375 18.4378 28.115C18.7339 28.3769 18.9607 28.7569 18.6676 29.286C18.3692 29.8123 17.8105 29.6235 17.5183 29.4206C17.2295 29.2113 15.3173 28.0972 15.3173 28.0972C15.3173 28.0972 17.4111 29.9825 17.7656 30.2265C18.1147 30.4675 17.8745 31.1221 17.7421 31.2802C17.6098 31.4383 17.2482 31.7522 16.6354 31.4535C16.0227 31.1548 13.7592 30.0426 13.7592 30.0426",
    fill: "#9C768C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9056 31.4382C13.9056 31.4382 11.7789 29.5355 11.3604 28.2975C10.9461 27.078 11.0731 25.0046 11.6395 23.2931C12.2059 21.5816 14.0947 18.8096 15.2935 19.5638C16.4923 20.3181 17.7034 21.567 18.8525 22.588C19.9983 23.6154 20.7282 24.2363 20.3092 24.9513C19.8902 25.6662 17.1241 24.1262 16.4567 23.6523C16.4567 23.6523 18.5985 25.7257 18.8823 25.9974C19.1783 26.2593 19.4249 26.8939 19.2025 27.3952C18.9891 27.893 18.1469 27.3919 17.9168 27.2706C17.6922 27.1521 15.884 26.0929 15.884 26.0929C15.884 26.0929 18.143 27.8375 18.4378 28.115C18.7339 28.3769 18.9607 28.7569 18.6676 29.286C18.3692 29.8123 17.8105 29.6235 17.5183 29.4206C17.2295 29.2113 15.3173 28.0972 15.3173 28.0972C15.3173 28.0972 17.4111 29.9825 17.7656 30.2265C18.1147 30.4675 17.8745 31.1221 17.7421 31.2802C17.6098 31.4383 17.2482 31.7522 16.6354 31.4535C16.0227 31.1548 13.7592 30.0426 13.7592 30.0426",
    stroke: "#040222",
    strokeWidth: 0.625455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8941 20.241C18.0421 19.2404 17.6877 20.2286 17.3013 20.8978L19.9874 23.5469L20.3771 23.7205C20.9594 23.3487 19.746 21.2416 18.8941 20.241Z",
    fill: "#9C768C",
    stroke: "#040222",
    strokeWidth: 0.625455,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5288 61.8745L72.5071 62.4355L73.0391 64.4605L69.78 72.6993L65.7131 69.2918L64.5288 61.8745Z",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4699 51.8397C60.722 51.4657 60.535 52.9616 61.2206 52.9616C61.9062 52.9616 62.2802 52.2137 61.4699 51.8397Z",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6379 56.9412C60.8899 56.5673 60.7029 58.0632 61.3886 58.0632C62.0742 58.0632 62.4482 57.3152 61.6379 56.9412Z",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.957 43.1757L65.0925 48.7231C65.0925 48.7231 63.9706 46.4792 62.537 45.9182",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.293 45.7926C59.293 45.7926 57.1114 47.1016 56.3634 48.3482C55.8648 44.2344 55.2415 43.1124 55.2415 43.1124",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2242 47.2885C60.7879 46.7899 60.227 47.7249 60.4139 48.0365C60.8503 48.5352 61.9099 48.0988 61.2242 47.2885Z",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5791 72.8189C79.2125 87.6742 73.8555 89.9728 73.8555 89.0153C73.9526 89.4101 75.0941 88.7281 77.8571 84.4331C80.6201 80.1382 84.1885 71.9999 85.5791 68.1587C85.6475 68.8426 85.4406 68.7653 85.5791 72.8189Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.716725,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5145 64.1692L41.3711 68.3907L38.4829 66.9269L40.5443 69.9868L39.862 71.7576",
    stroke: "#040222",
    strokeWidth: 0.358363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1758 56.7076C52.3556 53.4148 55.752 46.4883 57.0528 43.4366L56.2009 41.6625C55.5622 42.7033 53.263 47.1695 49.1758 56.7076Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.716725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.719 56.8383C10.719 56.8383 -0.851962 45.2674 3.21349 25.9565C8.99895 -1.71986 45.0408 -0.234409 56.6117 3.04923C68.1826 6.33286 88.7444 12.1965 81.9426 45.7365C75.1408 79.2765 25.4113 66.4546 20.7204 64.5C16.0295 62.5455 10.719 56.8383 10.719 56.8383Z",
    stroke: "#040222",
    strokeWidth: 0.781818,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTellUs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tell-us.a9e2e4248d67a126d62ce4d854a28693.svg";